import React from 'react';
import PropTypes from 'prop-types';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { buildMMYSubmodelTrimPhotosPathWithParams, PhotosModel } from 'client/data/models/photos';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { buildDisplayVehicle } from 'site-modules/shared/utils/core-page/display-name-builders';
import { getStaticImageUrl, getValidImageUrl } from 'client/utils/image-helpers';
import { NO_VEHICLE_GRAY_IMAGE_SEDAN } from 'site-modules/shared/constants/images';
import { Link } from 'site-modules/shared/components/link/link';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';

export function VehicleModuleUI({ vehicle = null, vehiclePhoto = null, showChangeButton = true }) {
  if (!vehicle) {
    return null;
  }

  const displayVehicle = buildDisplayVehicle({
    makeModelSubmodelYear: vehicle,
    params: {
      make: vehicle.make.slug,
      model: vehicle.model.slug,
      year: vehicle.year,
      submodel: vehicle.submodels.slug,
    },
    showSubmodel: false,
  });

  return (
    <Row className="vehicle-module text-gray-darker">
      <Col xs={4} md={3} className="mb-1_5 pe-0_75 pe-md-1_5">
        <AspectRatioContainer aspectRatio="3:2" className="w-100 rounded-8">
          <img src={getValidImageUrl(vehiclePhoto) || getStaticImageUrl(NO_VEHICLE_GRAY_IMAGE_SEDAN)} alt="" />
        </AspectRatioContainer>
      </Col>
      <Col xs={8} md={9}>
        <div className="vehicle-module-name heading-4 mb-0_5">{displayVehicle}</div>
        {showChangeButton && (
          <Link
            className="text-primary-darker d-inline-block mb-md-1_5"
            to="/car-reviews/consumer-ratings-reviews.html"
            data-tracking-id="wr_change_vehicle"
          >
            Change vehicle
            <i className="icon-arrow-right4 d-inline-block size-10 ps-0_25" aria-hidden />
          </Link>
        )}
      </Col>
    </Row>
  );
}

VehicleModuleUI.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear,
  vehiclePhoto: PropTypes.string,
  showChangeButton: PropTypes.bool,
};

export const VehicleModule = connectToModel(VehicleModuleUI, {
  vehiclePhoto: bindToPath(
    ({ vehicle }) =>
      vehicle &&
      buildMMYSubmodelTrimPhotosPathWithParams({
        make: vehicle.make.slug,
        model: vehicle.model.slug,
        year: vehicle.year,
      }),
    PhotosModel,
    photos => photos?.[0]?.href
  ),
});
